
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Svgs } from '../base/base.component';
import { IContractStateContext } from '../state-context/state-context.interface';
import { IContractState } from '../state.interface';
// -----------------------------------------------------------------------------------------
const _change = "change";
const _fileInput = "fileinput";
const _emptyFile = 'empty file';
const _applicationPdf = 'application/pdf';
const _applicationJpg = ['image/jpg','image/jpeg', ,'image/png','image/JPG','image/JPEG', ,'image/PNG'];
const _letter = 'Carta Compromiso';
const _select = 'Adjuntar';
const _upload = 'Enviar';
const _maxFileSize = 10000000;
const _fileTypeErrorMessage = 'Solo puede seleccionar archivos tipo pdf o jpg';
const _fileSizeErrorMessage = 'El tamaño máximo permitido del archivo son 4mb';
// -----------------------------------------------------------------------------------------
@Component({
  templateUrl: './generated.state.html',
  styleUrls: ['generated.state.css']
})
export class GeneratedStateComponent implements IContractState, AfterViewInit, OnDestroy {
  svg: Svgs = Svgs.ContractGenerated;
  fileTypeErrorMessage = _fileTypeErrorMessage;
  fileSizeErrorMessage = _fileSizeErrorMessage;
  selectedFile!: File;
  get hasSelectedFile(): boolean { return this.selectedFile != null; }
  get selectedFileName(): string { return this.hasSelectedFile ? this.selectedFile.name : _emptyFile }
  get buttonText(): string { return this.hasSelectedFile ? `${_upload} ${_letter}` : `${_select} ${_letter}`; }
  hasSelectedFileTypeError: boolean = false;
  hasSelectedFileSizeError: boolean = false;
  @Input() context!: IContractStateContext;
  @Input() contract: any;
  @ViewChild(_fileInput, { static: true }) fileinput: ElementRef;
  // -----------------------------------------------------------------------------------------
  onClick() {
    if (this.hasSelectedFile) {
      this.uploadFile();
    } else {
      this.fileinput.nativeElement.click();
    }
  }
  // -----------------------------------------------------------------------------------------
  handleFile() {
    const file = this.fileinput.nativeElement.files[0];
    
    if (file) {
      this.hasSelectedFileSizeError = (file.size > _maxFileSize);
      this.hasSelectedFileTypeError = (file.type !== _applicationPdf && !(_applicationJpg.includes(file.type )));

      if (!this.hasSelectedFileSizeError && !this.hasSelectedFileTypeError) {
        this.selectedFile = file;
      }
    }
  }
//-------------------------------------------------------------------------------------------------
/*
resize(itemfile) {

  var element = itemfile; 
  ImageTools.resize(element.files[0], {
      width: 1920,
      height: 1080
  }, function (blob, didItResize) {
      var file = new File([blob], (ListadeImagenes.length + 1) + ".jpg");
      ListadeImagenes.push(file);
    });
};*/
compressImage(src, newX, newY) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');
      elem.width = newX;
      elem.height = newY;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, newX, newY);
      const data = ctx.canvas.toDataURL();
      res(data);
    }
    img.onerror = error => rej(error);
  })
}

  // -----------------------------------------------------------------------------------------
  removeFile() { this.selectedFile = null; }
  // -----------------------------------------------------------------------------------------
  uploadFile() {
    this.context.setUploadingState(this.selectedFile);
  }
  // -----------------------------------------------------------------------------------------
  downloadFile() {
    window.open(this.contract.contractURL, "_blank");
  }
  // -----------------------------------------------------------------------------------------
  async nextState() {
    this.context.setInitialState();
  }
  // -----------------------------------------------------------------------------------------
  ngAfterViewInit(): void {
    this.fileinput.nativeElement.addEventListener(_change, this.handleFile.bind(this), false);
  }
  // -----------------------------------------------------------------------------------------
  ngOnDestroy(): void {
    this.fileinput.nativeElement.removeEventListener(_change, this.handleFile.bind(this), false);
  }
}
